var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-text-box',{ref:"authFormRef",attrs:{"column":1,"dataList":_vm.configList,"rules":_vm.rules,"model":_vm.model,"formProps":{ labelWidth: '260px' }}})
}
var staticRenderFns = []

export { render, staticRenderFns }